export const styles = {
  style: {
    fontWeight: "600",
    textDecorationLine: "underline"
  }
};
